import { Pool } from "../../utils/Pool";
import { ClassUtils } from "../../utils/ClassUtils";
import { Config } from "../../../Config";
import { Rectangle } from "../../maths/Rectangle";
import { Browser } from "../../utils/Browser";
import { Render2DProcessor } from "../Render2DProcessor";
const className = "FillTextCmd";
export class FillTextCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.color = '#ffffff';
        this.strokeColor = '#000000';
        this.stroke = 0;
        this.align = 'left';
        this.fontSize = 20;
        this.letterSpacing = 0;
        this.shadowOffsetX = 0;
        this.shadowOffsetY = 0;
        this.shadowBlur = 0;
        this.shadowColor = '#000000';
    }
    static create(text, x, y, font, color, align, stroke, strokeColor) {
        let cmd = Pool.getItemByClass(className, FillTextCmd);
        cmd.text = null;
        cmd.x = x;
        cmd.y = y;
        cmd.font = font;
        cmd.color = color !== null && color !== void 0 ? color : '#ffffff';
        cmd.stroke = stroke !== null && stroke !== void 0 ? stroke : 0;
        cmd.strokeColor = strokeColor !== null && strokeColor !== void 0 ? strokeColor : '#000000';
        cmd.text = text;
        cmd.align = align !== null && align !== void 0 ? align : 'left';
        cmd.singleCharRender = false;
        cmd._preMeasuredWidth = null;
        cmd.letterSpacing = 0;
        cmd.shadowOffsetX = 0;
        cmd.shadowOffsetY = 0;
        cmd.shadowBlur = 0;
        cmd.shadowColor = '#000000';
        return cmd;
    }
    get font() {
        if (!this._font)
            this._font = (this.bold ? "bold " : "") + this.fontSize + "px " + (this.fontFamily ? this.fontFamily : Config.defaultFont);
        return this._font;
    }
    set font(value) {
        this._font = value;
        if (!value) {
            this.fontFamily = null;
            this.fontSize = Config.defaultFontSize;
            return;
        }
        let words = value.split(' ');
        let l = words.length;
        if (l < 2) {
            if (l == 1) {
                if (words[0].indexOf('px') > 0) {
                    this.fontSize = parseInt(words[0]);
                }
            }
            this.fontFamily = null;
            return;
        }
        let szpos = -1;
        for (let i = 0; i < l; i++) {
            if (words[i].indexOf('px') > 0 || words[i].indexOf('pt') > 0) {
                szpos = i;
                this.fontSize = parseInt(words[i]);
                if (this.fontSize <= 0) {
                    console.debug('font parse error:' + value);
                    this.fontSize = 20;
                }
                break;
            }
        }
        let fpos = szpos + 1;
        let familys = words[fpos];
        fpos++;
        for (; fpos < l; fpos++) {
            familys += ' ' + words[fpos];
        }
        this.fontFamily = (familys.split(','))[0];
        this.italic = words.indexOf('italic') >= 0;
        this.bold = words.indexOf('bold') >= 0;
    }
    recover() {
        Pool.recover(className, this);
        this._preMeasuredWidth = null;
        if (this._renderInfo)
            Render2DProcessor.runner._textRender.freeRenderInfo(this._renderInfo);
    }
    get cmdID() {
        return FillTextCmd.ID;
    }
    run(runner, gx, gy) {
        if (!this.text) {
            if (this._renderInfo)
                runner._textRender.freeRenderInfo(this._renderInfo);
            return;
        }
        let tw = this.getTextWidth();
        switch (this.align) {
            case "center":
                gx -= tw / 2;
                break;
            case "right":
                gx -= tw;
                break;
        }
        this._renderInfo = runner._textRender.draw(this.text, this.x + gx, this.y + gy, this.fontFamily ? this.fontFamily : Config.defaultFont, this.fontSize, this.bold, this.italic, this.color, this.stroke, this.strokeColor, this.letterSpacing, this.shadowOffsetX, this.shadowOffsetY, this.shadowBlur, this.shadowColor, this.singleCharRender, tw, this._renderInfo);
    }
    getTextWidth() {
        if (this._preMeasuredWidth != null)
            return this._preMeasuredWidth;
        let ctx = Browser.context;
        ctx.font = this.font;
        return ctx.measureText(this.text).width;
    }
    getBounds(assembler) {
        let tw = this.getTextWidth();
        let x = this.x;
        let y = this.y;
        switch (this.align) {
            case "center":
                x -= tw / 2;
                break;
            case "right":
                x -= tw;
                break;
        }
        x -= 4;
        y -= this.fontSize / 2;
        Rectangle.TEMP.setTo(x, y, tw + 8, this.fontSize * 2).getBoundPoints(assembler.points);
    }
}
FillTextCmd.ID = className;
ClassUtils.regClass(className, FillTextCmd);
